<template>
  <main class="mobile-page products-screen">
    <div class="mobile-screen">
      <header class="mobile-topnav">
        <RouterLink class="mobile-icon-btn" to="/mobile" aria-label="返回首页">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M14.5 5.5 8 12l6.5 6.5" /></svg>
        </RouterLink>
        <span class="mobile-topnav-title">数字生态全景</span>
        <i class="nav-space"></i>
      </header>

      <section class="intro">
        <span class="mobile-eyebrow">Products · 生态全景</span>
        <h1>双产品引擎<br />贯通企业增长<br />与用户生态</h1>
        <p>以智能为桥梁，VitaeAI 智能体数字员工为企业构筑可持续在线的增长能力。</p>
        <p>以交互为入口，点指之间 APP 为用户开启数字价值的新连接。双产品引擎，贯通企业增长与用户生态，共同驱动可销售、可运营、可持续的数字商业未来。</p>
      </section>

      <section class="eco-flow" aria-label="企业增长、AI 生态与用户生态链路">
        <div class="eco-node">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#62f4d6" stroke-width="2" stroke-linecap="round"><path d="M4 18V9M10 18V5M16 18v-6M22 18H2" /></svg>
          <span>企业增长</span>
        </div>
        <i class="eco-link"></i>
        <div class="eco-node core">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#04110f" stroke-width="2.2" stroke-linecap="round"><circle cx="12" cy="12" r="3.2" /><circle cx="12" cy="12" r="8" opacity=".55" /></svg>
          <span>AI 生态</span>
        </div>
        <i class="eco-link"></i>
        <div class="eco-node violet">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9b8cff" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="7" r="3.2" /><circle cx="5.5" cy="18" r="3" /><circle cx="18.5" cy="18" r="3" /></svg>
          <span>用户生态</span>
        </div>
      </section>

      <section>
        <div class="mobile-sec-head">
          <h2>企业引擎 · VitaeAI</h2>
          <span class="mobile-sec-tag">AI Workforce</span>
        </div>
        <div v-if="productConfigLoading && !productConfigLoaded" class="mobile-card config-state">正在读取官方商品目录...</div>
        <div v-else-if="productConfigError && !websiteProducts.length" class="mobile-card config-state error">
          <p>{{ productConfigError }}</p>
          <button class="mobile-btn mobile-btn-ghost" type="button" @click="loadProductConfig(true)">重新加载商品信息</button>
        </div>
        <div v-else-if="!websiteProducts.length" class="mobile-card config-state">暂无可展示商品。</div>
        <template v-else>
          <RouterLink
            v-for="product in websiteProducts"
            :key="product.productCode"
            class="prod-card product-item"
            :to="`/mobile/employee/${encodeURIComponent(product.productCode)}`"
          >
            <span class="ph ph-employee">
              <img :src="productImage(product)" :alt="product.productName || 'VitaeAI 商品'" loading="lazy" />
              <i class="ph-grid"></i>
            </span>
            <span class="pb">
              <span class="row">
                <h3>{{ product.productName || '官方商品' }}</h3>
                <strong class="price">{{ productPrice(product) }}</strong>
              </span>
              <p class="pdesc copy-preline">{{ [product.subtitle, product.formText, product.servicePeriod].filter(Boolean).join(' · ') || '查看商品详情' }}</p>
              <p v-if="product.description" class="pdesc compact copy-preline">{{ product.description }}</p>
              <span class="ptags"><span v-for="item in product.includesList" :key="item">{{ item }}</span></span>
              <span class="ptags">
                <span v-for="method in product.allowedPaymentMethods" :key="method">支持{{ paymentMethodText(method) }}</span>
              </span>
            </span>
          </RouterLink>
        </template>
        <div v-if="websiteProducts.length" class="metric3">
          <div>
            <strong>{{ websiteProducts.length }}</strong>
            <span>在售商品</span>
          </div>
          <div><strong>官方配置</strong><span>实时目录</span></div>
          <div><strong>安全下单</strong><span>服务端计价</span></div>
        </div>
<!--        <div class="mobile-card workflow-card">-->
<!--          <span class="mobile-eyebrow title">Workflow · 三步增长闭环</span>-->
<!--          <div class="workflow">-->
<!--            <div v-for="step in workflows" :key="step.no" class="wf-step">-->
<!--              <i class="wf-no">{{ step.no }}</i>-->
<!--              <div><strong>{{ step.title }}</strong><p>{{ step.text }}</p></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </section>

      <section>
        <div class="mobile-sec-head">
          <h2>用户引擎 · 点指之间</h2>
          <span class="mobile-sec-tag violet">Consumer App</span>
        </div>
        <RouterLink class="prod-card" to="/mobile/app">
          <span class="ph ph-app"><img src="/images/pexels-mobile-app-night.jpg" alt="点指之间 APP" loading="lazy" /><i class="ph-grid"></i><i class="ph-phone"></i></span>
          <span class="pb">
            <span class="row"><h3>点指之间 APP</h3><strong class="price violet">免费参与</strong></span>
            <p class="pdesc">让每一次交互都有价值回响，让每一个普通人都能公平享受数字文明带来的繁荣。</p>
            <p class="pdesc compact">用户在内容消费、广告互动、游戏娱乐、签到与分享中的有效参与，将获得活跃积分，并通过 AI 驱动的动态转换机制沉淀为能量积分，用于生态消费与未来更多生活场景。</p>
            <span class="ptags"><span>内容与互动</span><span>游戏娱乐</span><span>签到分享</span><span>活跃积分</span><span>能量积分</span><span>生态消费</span></span>
          </span>
        </RouterLink>
        <div class="metric3">
          <div class="is-violet"><strong>行为即价值</strong><span>参与机制</span></div>
          <div class="is-violet"><strong>活跃 → 能量</strong><span>持续流转</span></div>
          <div class="is-violet"><strong>持续流转</strong><span>生态权益</span></div>
        </div>
      </section>

      <section>
        <div class="mobile-sec-head">
          <h2>生态运转场景</h2>
          <span class="mobile-sec-tag">Scenarios</span>
        </div>
        <div class="mobile-hscroll">
          <article v-for="scene in scenes" :key="scene.title" class="scene-card" :class="scene.theme">
            <span class="sc-badge">{{ scene.en }}</span><strong>{{ scene.title }}</strong><p>{{ scene.text }}</p>
          </article>
        </div>
      </section>

      <RouterLink class="cta-banner" :to="firstProductPath">
        <span><strong>即刻拥有你的 AI 增长团队</strong><p>选择适合企业的 VitaeAI 商品</p></span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#04110f" stroke-width="2.6" stroke-linecap="round"><path d="M9 5.5 15.5 12 9 18.5" /></svg>
      </RouterLink>
    </div>
  </main>
</template>

<script setup>
import { onMounted } from 'vue'
import { paymentMethodText, useWebsiteProductConfig } from '@/composables/useWebsiteProductConfig'

const {
  websiteProducts,
  productConfigLoaded,
  productConfigLoading,
  productConfigError,
  loadProductConfig,
  productConfig
} = useWebsiteProductConfig()

const firstProductPath = '/mobile/employee'

/**
 * 根据商品类型选择官方示意图。
 * @param product 商品对象
 * @returns {string} 图片地址
 */
function productImage(product) {
  const code = String(product?.productCode || '').toUpperCase()
  if (code.includes('GEO')) return '/images/pexels-content-timeline.jpg'
  if (code.includes('CUSTOMER')) return '/images/pexels-growth-dashboard.jpg'
  if (code.includes('CITY_PARTNER')) return '/images/pexels-private-ops-laptop.jpg'
  return '/images/pexels-humanoid-robot.jpg'
}

/**
 * 展示商品单价。
 * @param product 商品对象
 * @returns {string} 价格文本
 */
function productPrice(product) {
  if (productConfig.value.priceHidden === true) return '价格确认'
  return `¥${Number(product?.unitPrice || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2 })}`
}

const workflows = [
  { no: '01', title: 'AI 内容工厂', text: '围绕企业需求与用户画像生成文案、图像、短视频等内容，持续积累品牌内容资产。' },
  { no: '02', title: '精准触达与引流', text: '基于目标用户特征规划触达与互动，让品牌内容更有效地连接潜在客户。' },
  { no: '03', title: '私域承接与转化', text: '通过知识库问答、需求识别和个性化推荐，持续服务客户并促进转化复购。' }
]

onMounted(() => {
  loadProductConfig().catch(() => {})
})
const scenes = [
  { en: 'Content Engine', title: '内容创作', text: 'AI 持续产出文案与视觉素材，积累品牌内容资产', theme: 'sc-cyan' },
  { en: 'Public Traffic', title: '公域曝光', text: '智能触达连接目标用户，让内容有效连接客户', theme: 'sc-violet' },
  { en: 'Private CRM', title: '私域经营', text: '知识库问答承接咨询，个性化推荐促进转化复购', theme: 'sc-gold' }
]
</script>

<style scoped>
.products-screen { padding-bottom: calc(34px + env(safe-area-inset-bottom)); }
.nav-space { width: 36px; flex: 0 0 36px; }
.intro { padding: 12px 2px 4px; }
.intro h1 { margin: 12px 0; font-size: 25px; line-height: 1.32; font-weight: 900; }
.intro p { color: var(--mobile-muted); font-size: 12px; line-height: 1.75; }
.intro p + p { margin-top: 6px; }
.eco-flow { display: flex; align-items: center; gap: 9px; margin: 16px 0 4px; }
.eco-node { flex: 1; display: flex; flex-direction: column; align-items: center; gap: 7px; padding: 12px 6px; border: 1px solid rgba(98,244,214,.28); border-radius: 14px; background: radial-gradient(80px 50px at 50% 0%, rgba(98,244,214,.14), transparent 72%), rgba(255,255,255,.03); }
.eco-node span { color: var(--mobile-muted); font-size: 11px; font-weight: 800; }
.eco-node.core { border-color: rgba(98,244,214,.55); background: radial-gradient(90px 60px at 50% 0%, rgba(98,244,214,.28), transparent 75%), rgba(98,244,214,.1); box-shadow: 0 0 24px rgba(98,244,214,.18); }
.eco-node.core span { color: #a8f7e4; }
.eco-node.violet { border-color: rgba(155,140,255,.3); background: radial-gradient(80px 50px at 50% 0%, rgba(155,140,255,.15), transparent 72%), rgba(255,255,255,.03); }
.eco-node.violet span { color: #c9c0ff; }
.eco-link { flex: 0 0 16px; position: relative; height: 1px; background: linear-gradient(90deg, rgba(98,244,214,.5), rgba(155,140,255,.5)); }
.eco-link::after { content: ""; position: absolute; top: -2px; right: -1px; width: 5px; height: 5px; border-radius: 50%; background: rgba(155,140,255,.7); box-shadow: 0 0 8px rgba(155,140,255,.8); animation: pulse 2s ease-in-out infinite; }
.metric3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 8px; margin-top: 12px; }
.metric3 div { position: relative; overflow: hidden; padding: 12px 8px; border: 1px solid var(--mobile-line); border-radius: 12px; text-align: center; background: linear-gradient(180deg, rgba(98,244,214,.07), rgba(255,255,255,.015)); }
.metric3 div::before { content: ""; position: absolute; top: 0; right: 20%; left: 20%; height: 1.5px; background: linear-gradient(90deg, transparent, rgba(98,244,214,.6), transparent); }
.metric3 strong { display: block; color: var(--mobile-cyan); font-size: 13px; font-weight: 900; }
.metric3 span { display: block; margin-top: 3px; color: var(--mobile-quiet); font-size: 10px; font-weight: 600; }
.metric3 .is-violet { border-color: rgba(155,140,255,.24); background: linear-gradient(180deg, rgba(155,140,255,.08), rgba(255,255,255,.015)); }
.metric3 .is-violet::before { background: linear-gradient(90deg, transparent, rgba(155,140,255,.65), transparent); }
.metric3 .is-violet strong { color: var(--mobile-violet); }
.workflow-card { margin-top: 12px; }
.config-state { display: grid; gap: 12px; justify-items: center; margin-top: 12px; color: var(--mobile-muted); font-size: 12.5px; text-align: center; }
.config-state.error { color: #ff9c9c; }
.config-state .mobile-btn { width: 100%; }
.workflow-card .title { margin-bottom: 12px; }
.workflow { display: flex; flex-direction: column; }
.wf-step { position: relative; display: flex; gap: 12px; padding-bottom: 16px; }
.wf-step:last-child { padding-bottom: 0; }
.wf-step::before { content: ""; position: absolute; top: 34px; bottom: 2px; left: 15px; width: 1px; background: linear-gradient(180deg, rgba(98,244,214,.4), rgba(98,244,214,.08)); }
.wf-step:last-child::before { display: none; }
.wf-no { width: 31px; height: 31px; flex: 0 0 31px; display: flex; align-items: center; justify-content: center; border: 1.5px solid rgba(98,244,214,.5); border-radius: 50%; color: var(--mobile-cyan); font-size: 11px; font-weight: 900; background: rgba(98,244,214,.08); font-style: normal; }
.wf-step strong { display: block; margin-bottom: 3px; font-size: 13.5px; font-weight: 800; }
.wf-step p { color: var(--mobile-quiet); font-size: 11px; line-height: 1.6; }
.scene-card { flex: 0 0 168px; position: relative; overflow: hidden; padding: 14px; border: 1px solid var(--mobile-line); border-radius: 15px; background: linear-gradient(165deg, rgba(255,255,255,.055), rgba(255,255,255,.015)); }
.scene-card::before { content: ""; position: absolute; right: 0; bottom: 0; left: 0; height: 2.5px; }
.sc-badge { position: absolute; top: 11px; right: 11px; color: var(--mobile-faint); font-size: 8px; font-weight: 800; letter-spacing: .1em; text-transform: uppercase; }
.scene-card strong { display: block; margin: 6px 0 7px; font-size: 15px; font-weight: 900; }
.scene-card p { position: relative; z-index: 1; color: var(--mobile-quiet); font-size: 10px; line-height: 1.62; }
.sc-cyan::before { background: linear-gradient(90deg, var(--mobile-cyan), transparent); }.sc-cyan strong { color: #a8f7e4; }
.sc-violet::before { background: linear-gradient(90deg, var(--mobile-violet), transparent); }.sc-violet strong { color: #c3bcff; }
.sc-gold::before { background: linear-gradient(90deg, var(--mobile-gold), transparent); }.sc-gold strong { color: #ffe0a8; }
.cta-banner { position: relative; display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-top: 18px; padding: 15px 16px; border: 1px solid rgba(98,244,214,.35); border-radius: 15px; overflow: hidden; text-decoration: none; color: inherit; background: linear-gradient(120deg, rgba(98,244,214,.2), rgba(98,244,214,.07) 60%, rgba(155,140,255,.12)); }
.cta-banner::before { content: ""; position: absolute; top: -40px; right: -20px; width: 110px; height: 110px; border-radius: 50%; background: radial-gradient(circle, rgba(98,244,214,.22), transparent 70%); }
.cta-banner strong { display: block; font-size: 13.5px; font-weight: 900; }
.cta-banner p { margin-top: 3px; color: var(--mobile-muted); font-size: 10.5px; font-weight: 600; }
.cta-banner svg { position: relative; z-index: 1; flex: 0 0 auto; }
.ph { height: 128px; position: relative; display: flex; align-items: center; justify-content: center; overflow: hidden; }
.ph img { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; }
.ph::after { content:""; position:absolute; inset:0; background:linear-gradient(180deg,rgba(2,5,13,.18),rgba(2,5,13,.72)); }
.ph-employee { background: radial-gradient(140px 90px at 50% 110%, rgba(98,244,214,.35), transparent 70%), linear-gradient(150deg,#0d2137,#0a1830 60%,#071021); }
.ph-app { background: radial-gradient(140px 90px at 50% 110%, rgba(155,140,255,.32), transparent 70%), linear-gradient(150deg,#1b1836,#12102a 60%,#0a0918); }
.ph-grid { position: absolute; inset: 0; background-image: linear-gradient(rgba(222,246,255,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(222,246,255,.05) 1px,transparent 1px); background-size: 22px 22px; mask-image: linear-gradient(180deg,transparent,#000 60%); }
.ph-robot { position: relative; z-index: 2; width: 56px; height: 56px; display: flex; align-items: center; justify-content: center; border: 1px solid rgba(98,244,214,.4); border-radius: 16px; background: rgba(4,12,22,.75); box-shadow: 0 0 26px rgba(98,244,214,.35); }
.ph-phone { position: relative; z-index: 2; width: 34px; height: 56px; border: 1.5px solid rgba(155,140,255,.55); border-radius: 9px; background: rgba(4,12,22,.8); box-shadow: 0 0 26px rgba(155,140,255,.4); }
.prod-card { position: relative; overflow: hidden; border: 1px solid var(--mobile-line); border-radius: 18px; color: inherit; text-decoration: none; background: linear-gradient(170deg,rgba(16,28,48,.6),rgba(8,16,30,.82)); box-shadow: 0 10px 32px rgba(0,0,0,.3); }
.pb { display: block; padding: 14px 16px 16px; }
.row { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.pb h3 { font-size: 15.5px; font-weight: 800; }
.price { color: var(--mobile-cyan); font-size: 16px; font-weight: 900; white-space: nowrap; }.price.violet { color: var(--mobile-violet); }
.pdesc { margin-top: 7px; color: var(--mobile-quiet); font-size: 11px; line-height: 1.72; }.pdesc.compact { margin-top: 6px; }
.ptags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 11px; }.ptags span { padding: 3px 8px; border: 1px solid var(--mobile-line-strong); border-radius: 6px; color: var(--mobile-muted); font-size: 10px; font-weight: 700; background: rgba(255,255,255,.03); }.ptags span:nth-child(1) { color:#a8f7e4;border-color:rgba(98,244,214,.3);background:rgba(98,244,214,.07); }
@keyframes pulse { 0%,100% { opacity:.5; } 50% { opacity:1; } }
</style>
